import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
import logo from '../assets/images/logos/text_logo_white.png';
import logo_black from '../assets/images/logos/text_logo_black.png';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/index.ts';
import { removeFromCart } from '../store/slices/cartSlice.ts';
import { HashLink } from 'react-router-hash-link';


const Header = () => {
    const [isSticky, setIsSticky] = useState(false);
    const location = useLocation(); // Get the current route

    const [posWrapHeader, setPosWrapHeader] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState({}); // To track multiple submenus
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [cartVisible, setCartVisible] = useState(false);
    const cartItems = useSelector((state) => state.cart?.items || []);
    const dispatch = useDispatch();
    const totalQuantity = cartItems.reduce(
        (total, item) => total + item.quantity,
        0
      );

    const totalPrice = cartItems.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    ).toFixed(2);
    const handleRemoveItem = (id) => {
      dispatch(removeFromCart(id));
    };

    // Toggle mobile menu visibility
    const toggleMobileMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Toggle specific submenu visibility
    const toggleSubMenu = (menuIndex) => {
        setSubMenuOpen((prevState) => ({
            ...prevState,
            [menuIndex]: !prevState[menuIndex],
        }));
    };
    // Toggle cart visibility
    const toggleCartVisibility = () => {
        setCartVisible(!cartVisible);
    };
    // Resize handling to close mobile menu when resizing above breakpoint
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            if (window.innerWidth >= 992) {
                setMenuOpen(false); // Close menu on larger screens
                setSubMenuOpen({}); // Close all submenus
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const topBarElement = document.querySelector('.top-bar');
        setPosWrapHeader(topBarElement ? topBarElement.clientHeight : 0);

        const handleScroll = () => {
            setIsSticky(window.scrollY > posWrapHeader);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [posWrapHeader]);

    return (
        <header className="">
            {/* Header Desktop */}
            <div className={`container-menu-desktop ${isSticky ? 'fix-menu-desktop' : ''}`}>
                {/* Topbar */}
                <div className="top-bar">
                    <div className="content-topbar flex-sb-m h-full container">
                        <div className="left-top-bar">Free shipping for standard orders over $25 (USA)</div>
                        <div className="right-top-bar flex-w h-full">
                            <HashLink smooth to="/#faq" className="btn btn-link">
                            Help & FAQs
                            </HashLink>
                            <a href="/" className="flex-c-m trans-04 p-lr-25">My Account</a>
                        </div>
                    </div>
                </div>

                {/* Menu Desktop */}
                <div className="wrap-menu-desktop">
                    <nav className="limiter-menu-desktop container">
                        {/* Logo */}
                        <a className="logo" href="/">
                            {/* Conditional logo rendering based on sticky state */}
                            <img src={isSticky ? logo_black : logo_black} alt="Molu" />
                        </a>

                        {/* Main Menu */}
                        <div className="menu-desktop">
                            <ul className="main-menu">
                                <li className={location.pathname === "/" ? "active-menu" : ""}>
                                    <Link to="/">Home</Link>
                                </li>
                                <li className={location.pathname === "/shop" ? "active-menu" : ""}>
                                    <Link to="/shop">Shop</Link>
                                </li>
                                <li className={location.pathname.startsWith("/blog") ? "active-menu" : ""}>
                                    <Link to="/blog">Blog</Link>
                                </li>
                                <li className={location.pathname.startsWith("/about") ? "active-menu" : ""}>
                                    <Link to="/about">About</Link>
                                </li>
                                {/* <li className={location.pathname.startsWith("/social-responsibility") ? "active-menu" : ""}>
                                    <Link to="/social-responsibility">Social Responsibility</Link>
                                </li> */}
                                <li className={location.pathname.startsWith("/glossary") ? "active-menu" : ""}>
                                    <Link to="/glossary">Glossary</Link>
                                </li>
                                <li className={location.pathname.startsWith("/contact") ? "active-menu" : ""}>
                                    <Link to="/contact">Contact</Link>
                                </li>
                            </ul>
                        </div>

                        {/* Social Icons */}
                        <div className="wrap-icon-header flex-w flex-r-m">
                            <div className={`header-social ${isSticky ? 'fix-menu-social' : 'fix-menu-social'}`}>
                                <a href="https://www.youtube.com/channel/UCUVzLhFqQzavjNhlsPOH4Bg" className="social-icon" target="_blank"><FontAwesomeIcon icon={faYoutube} /></a>
                                <a href="https://www.facebook.com/people/Molu-Wellness/61576808587286/" className="social-icon" target="_blank"><FontAwesomeIcon icon={faFacebookF} /></a>
                                <a href="https://www.instagram.com/moluwellness" className="social-icon" target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
                            </div>
                            <div
                                className="icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11 icon-header-noti js-show-cart"
                                data-notify={totalQuantity}
                                onClick={toggleCartVisibility}
                            >
                                <i className="zmdi zmdi-shopping-cart" style={{'color':'#333'}}></i>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>

            {/* Header Mobile */}
            <div className="wrap-header-mobile">
                {/* Logo Mobile */}
                <div className="logo-mobile">
                    <a href="/"><img src={logo_black} alt="Molu" /></a>
                </div>

                {/* Mobile Icons */}
                <div className="wrap-icon-header flex-w flex-r-m m-r-15">
                    <div
                        className="icon-header-item cl2 hov-cl1 trans-04 p-l-22 p-r-11 icon-header-noti js-show-cart"
                        data-notify={totalQuantity}
                        onClick={toggleCartVisibility}
                    >
                        <i className="zmdi zmdi-shopping-cart"></i>
                    </div>
                </div>

                {/* Mobile Menu Button */}
                <div 
                    className={`btn-show-menu-mobile hamburger hamburger--squeeze ${menuOpen ? 'is-active' : ''}`} 
                    onClick={toggleMobileMenu}
                >
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`menu-mobile ${menuOpen ? 'open' : ''}`}
            style={{ display: menuOpen ? 'block' : 'none' }}>
                <ul className="topbar-mobile">
                    <li><div className="left-top-bar">Free shipping for standard order over $25 (USA)</div></li>
                    <li>
                        <div className="right-top-bar flex-w h-full">
                            <HashLink smooth to="/#faq" className="btn btn-link">
                            Help & FAQs
                            </HashLink>
                            <a href="/" className="flex-c-m p-lr-10 trans-04">My Account</a>
                        </div>
                    </li>
                </ul>
                <ul className="main-menu-m">
                    <li><a href="/">Home</a></li>
                    <li><a href="/shop">Shop</a></li>
                    <li><a href="/blog">Blog</a></li>
                    <li><a href="/about">About</a></li>
                    {/* <li><a href="/social-responsibility">Social Responsibility</a></li> */}
                    <li><a href="/glossary">Glossary</a></li>
                    <li><a href="/contact">Contact</a></li>
                </ul>
            </div>

            {/* Modal Search */}
            <div className="modal-search-header flex-c-m trans-04 js-hide-modal-search">
                <div className="container-search-header">
                    <button className="flex-c-m btn-hide-modal-search trans-04 js-hide-modal-search">
                        <img src="/images/icons/icon-close2.png" alt="Close" />
                    </button>
                    <form className="wrap-search-header flex-w p-l-15">
                        <button className="flex-c-m trans-04"><i className="zmdi zmdi-search"></i></button>
                        <input className="plh3" type="text" name="search" placeholder="Search..." />
                    </form>
                </div>
            </div>

            <div className={`wrap-header-cart js-panel-cart ${cartVisible ? 'show-header-cart' : ''}`}>
            {/* Overlay for closing cart */}
            {cartVisible && (
                <div className="s-full js-hide-cart" onClick={toggleCartVisibility}></div>
            )}

            {/* Cart Content Section */}
            <div className="header-cart flex-col-l p-l-65 p-r-25">
                {/* Cart Header Section */}
                <div className="header-cart-title flex-w flex-sb-m p-b-8">
                    <span className="mtext-103 cl2">Your Cart</span>
                    <div 
                        className="fs-35 lh-10 cl2 p-lr-5 pointer hov-cl1 trans-04 js-hide-cart"
                        onClick={toggleCartVisibility}
                    >
                        <i className="zmdi zmdi-close"></i>
                    </div>
                </div>

                {/* Cart Items Section */}
                <div className="header-cart-content flex-w js-pscroll">
                    <ul className="header-cart-wrapitem w-full">
                    {cartItems.map((item) => (
                        <li key={item.id} className="header-cart-item flex-w flex-t m-b-12">
                        <div className="header-cart-item-img">
                            <img src={item.image} alt={item.name} />
                        </div>
                        <div className="header-cart-item-txt p-t-8">
                            <a href="/" className="header-cart-item-name m-b-18 hov-cl1 trans-04">
                            {item.name}
                            </a>
                            <span className="header-cart-item-info">
                            {item.quantity} x ${item.price.toFixed(2)}
                            </span>
                            <button onClick={() => handleRemoveItem(item.id)} className="btn btn-sm btn-danger mt-2">
                            Remove
                            </button>
                        </div>
                        </li>
                    ))}
                    </ul>

                    {/* Total Section */}
                    <div className="w-full">
                        <div className="header-cart-total w-full p-tb-40">
                            Total: ${totalPrice}
                        </div>
                        <div className="header-cart-buttons flex-w w-full">
                            <a href="/shop/shopping-cart" className="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-r-8 m-b-10">
                                View Cart
                            </a>
                            <a href="/shop/shopping-cart" className="flex-c-m stext-101 cl0 size-107 bg3 bor2 hov-btn3 p-lr-15 trans-04 m-b-10">
                                Check Out
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </header>
    );
};

export default Header;
